import { Button, Form, Modal, notification } from "antd";
import dayjs from "dayjs";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { createExpense } from "store/slices/expensesSlice";
import { closeModal } from "store/slices/modalsSlice";
import { getSchools } from "store/slices/schoolsSlice";
import ExpenseForm from "./expense-form";

const NewExpenseModal = () => {
  const { t } = useTranslation();
  const [form] = Form?.useForm();
  const dispatch = useDispatch();
  const { isModalOpen, modalType } = useSelector((state) => state?.modals);
  const { loading } = useSelector((state) => state?.expenses);
  const { schools } = useSelector((state) => state?.schools);
  const open = isModalOpen && modalType === "new_expense";

  const { userData } = useSelector((state) => state?.auth);
  useEffect(() => {
    if (open) {
      if (userData?._id) dispatch(getSchools(userData?._id));
    }
  }, [dispatch, open, userData?._id]);

  const onSubmit = async (values) => {
    if (values?.purchaseDate) {
      values.purchaseDate = dayjs(values?.purchaseDate)?.format("YYYY-MM-DD");
    }

    return await dispatch(createExpense(values))?.unwrap()?.then(() => {
        notification?.success({
          message: t("expenses.crud.form.success"),
        });
        onClose();
      })?.catch((error) => {
        notification?.error({
          message: t("expenses.crud.form.error.failed"),
        });
      });
  };

  const onClose = () => {
    form?.resetFields();
    dispatch(closeModal());
  };
  return (
    <Modal
      title={<h4 style={{ textAlign: "center" }}>{t("expenses.crud.form")}</h4>}
      open={open}
      onCancel={onClose}
      destroyOnClose
      footer={[
        <Button key="cancel" onClick={onClose}>
          {t("expenses.crud.form.button.cancel")}
        </Button>,
        <Button
          key="submit"
          type="primary"
          htmlType="submit"
          form="expense_form"
          disabled={loading}
        >
          {t("expenses.crud.form.button.save")}
        </Button>,
      ]}
      centered
      styles={{ content: { overflowY: "auto", maxHeight: "75vh" } }}
    >
      <ExpenseForm schools={schools} onSubmit={onSubmit} />
    </Modal>
  );
};

export default NewExpenseModal;
